(() => {
  "use strict";
  if (window.OrnataSampleAtelier) {
    window.OrnataSampleAtelier.scan(document);
    return;
  }
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const abort = new AbortController(),
      signal = abort.signal,
      animations = new Set();
    const on = (target, event, handler) =>
      target?.addEventListener(event, handler, { signal });
    const config = JSON.parse(
      root.querySelector("[data-atelier-config]").textContent,
    );
    const data = window.OrnataSampleAtelierData;
    let response = null,
      inventoryReady = false,
      catalogReady = false,
      busy = false,
      disposed = false;
    const rawCatalog = JSON.parse(
      root.querySelector("[data-atelier-catalog]").textContent,
    );
    const storageKey = "ornata-sample-service-v3:" + config.productId;
    const form = root.querySelector("form[data-atelier-form]");
    const createBox = (stage, options) =>
      window.createOrnataSampleBox(stage, {
        ...options,
        assets: config.assets,
        signal,
      });

    const selector = (s) =>
      s.replace(/#([\w-]+)/g, (_, name) => '[data-at="' + name + '"]');
    const $ = (s) => root.querySelector(selector(s)),
      all = (s) => [...root.querySelectorAll(selector(s))];
    const descriptionToggle = $("[data-description-toggle]"),
      descriptionMore = $("[data-description-more]");
    if (descriptionToggle && descriptionMore) {
      const smallScreen = matchMedia("(max-width: 800px)");
      let descriptionExpanded = false;
      const syncDescription = () => {
        const open = !smallScreen.matches || descriptionExpanded;
        descriptionMore.hidden = !open;
        descriptionToggle.hidden = !smallScreen.matches;
        descriptionToggle.setAttribute("aria-expanded", String(open));
        descriptionToggle.textContent = descriptionExpanded
          ? "Lees minder"
          : "Lees meer…";
      };
      on(descriptionToggle, "click", () => {
        descriptionExpanded = !descriptionExpanded;
        syncDescription();
      });
      on(smallScreen, "change", syncDescription);
      syncDescription();
    }
    let catalog = [];
    const money = (n, compact = false) =>
      new Intl.NumberFormat(config.locale || "nl-NL", {
        style: "currency",
        currency: config.currency || "EUR",
        minimumFractionDigits: compact && n % 100 === 0 ? 0 : 2,
      }).format(n / 100);
    function mergeCatalog(items) {
      for (const item of items) {
        const id = String(item.id || item.productId || "");
        if (!id) continue;
        const record = {
          ...item,
          id,
          name: item.name || item.title || "",
          brand: item.brand || item.vendor || "",
          image: item.image || item.imageUrl || "",
          families: data.list(item.families),
          notes: Object.fromEntries(
            Object.entries(item.notes || {}).map(([k, v]) => [k, data.list(v)]),
          ),
        };
        const at = catalog.findIndex((p) => p.id === id);
        if (at < 0) catalog.push(record);
      }
    }
    mergeCatalog(rawCatalog.products);
    const esc = (s) =>
      String(s ?? "").replace(
        /[&<>"']/g,
        (c) =>
          ({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
          })[c],
      );
    const product = (id) => catalog.find((p) => p.id === String(id));
    let sets = [];
    const families = [
      ["Bloemig", "Zacht & expressief", "#ead1ce", "#a87878"],
      ["Houtachtig", "Aards & omhullend", "#c4ba97", "#777a51"],
      ["Oriëntaals", "Warm & rijk", "#c9a46f", "#73523b"],
      ["Citrus", "Helder & sprankelend", "#f2e5a2", "#b7b470"],
      ["Fris", "Licht & luchtig", "#e2e9df", "#9cbaa6"],
      ["Kruidig", "Gelaagd & karaktervol", "#d1b697", "#8e5e47"],
      ["Fruitig", "Sappig & levendig", "#e3c0ab", "#bd7f6e"],
      ["Gourmand", "Romig & verleidelijk", "#e5d2b1", "#ad8f68"],
    ];
    let saved = {};
    try {
      saved = JSON.parse(localStorage.getItem(storageKey) || "{}");
    } catch {}
    let selected = Array.isArray(saved.selected)
      ? [...new Set(saved.selected)].filter((id) => product(id)).slice(0, 5)
      : [];
    let slotIds =
      Array.isArray(saved.slotIds) && saved.slotIds.length === 5
        ? saved.slotIds.map((id) => (selected.includes(id) ? id : null))
        : Array.from({ length: 5 }, (_, i) => selected[i] || null);
    function syncSlotIds() {
      slotIds = slotIds.map((id) => (selected.includes(id) ? id : null));
      for (const id of selected)
        if (!slotIds.includes(id)) slotIds[slotIds.indexOf(null)] = id;
    }
    function slottedProducts() {
      syncSlotIds();
      return slotIds.map((id) => (id ? product(id) : null));
    }
    let mode = ["self", "sets", "guide", "surprise"].includes(saved.mode)
      ? saved.mode
      : "self";
    let guide = { families: [], intensity: [], types: {}, notes: "" };
    if (saved.guide)
      guide = data.sanitize({ type: "guide", profile: saved.guide }).profile;
    let surprise = data.sanitize({
      type: "surprise",
      profile: saved.surprise || {},
    }).profile;
    let step = 0,
      filter = "Alle",
      sort = "default",
      search = "",
      review = false,
      selectedSet = saved.selectedSet || null,
      builderModel = null,
      heroModel = null,
      builderPromise = null,
      toastTimer;
    let confirmedSet = data.sanitize(saved.confirmedSet);
    const helperCopy = JSON.parse(
      root.querySelector("[data-guide-copy]").textContent,
    );
    const ht = (key) => helperCopy[key] || "";
    const helperSteps = [
      {
        id: "mood",
        choices: ["clean", "fruit", "warm", "green", "floral", "any"],
        multi: true,
      },
      {
        id: "occasion",
        choices: ["day", "work", "evening", "any"],
        multi: true,
      },
      {
        id: "presence",
        choices: ["soft", "balanced", "bold", "any"],
        multi: true,
      },
      { id: "adventure", choices: ["familiar", "mix", "discover"] },
      { id: "premium", choices: ["0", "2", "5"] },
    ];
    let helperActive = false,
      helperStep = 0,
      helperAnswers = {},
      helperResult = [];
    function helperProducts() {
      return catalog.map((p) => {
        const s = response?.byProductId?.[p.id];
        return {
          ...p,
          title: p.name,
          families: p.families.join(", "),
          notes: Object.values(p.notes).flat().join(", "),
          noteGroups: p.notes,
          projection: s?.projection || "",
          choiceCount: s?.choiceCount || 0,
          available: available(p),
          storeExclusive: !!s?.storeExclusive,
          premium: s?.sampleSurchargeCents > 0,
          surcharge: Number(s?.sampleSurchargeCents || 0),
        };
      });
    }
    function renderHelper() {
      if (helperStep === helperSteps.length) {
        const valid =
          helperResult.length === 5 &&
          data.price(
            { type: "self", ids: helperResult.map((p) => p.id) },
            response,
          );
        content.innerHTML = `<div class="choice-heading"><h2>${esc(ht("result_title"))}</h2></div><p class="guide-intro">${esc(ht("result_sub"))}</p><div class="review-list">${helperResult.map((p, i) => `<div class="review-item"><img src="${esc(p.image)}" alt="" width="80" height="100"><div>${esc(p.title)}<small>${esc(p.brand)}</small><small>${esc(p.noteGroups?.notes?.join(", ") || p.families)}</small></div><button type="button" class="link atelier-text-link" data-helper-swap="${i}">${esc(ht("swap"))}</button></div>`).join("")}</div>${valid ? `<p class="guide-intro">${money(valid.price)}</p>` : `<p role="status">${esc(ht("not_enough"))}</p>`}<div class="guide-footer"><button type="button" class="link" data-helper-back>${esc(ht("edit_answers"))}</button><button type="button" class="button" data-helper-use ${valid ? "" : "disabled"}>${esc(ht("use_selection"))}</button></div>`;
        return;
      }
      const current = helperSteps[helperStep],
        chosen = [helperAnswers[current.id]].flat().filter(Boolean);
      content.innerHTML = `<div class="guide-progress">${helperSteps.map((_, i) => `<span class="${i <= helperStep ? "done" : ""}"></span>`).join("")}</div><div class="choice-heading"><h2>${esc(current.id === "premium" ? "Mogen er premium samples bij?" : ht(current.id + "_title"))}</h2></div><p class="guide-intro">${esc(current.id === "premium" ? "Je ziet de actuele toeslagen en het totaal bij jouw voorstel." : ht(current.id + "_sub"))}</p><div class="intensity-options">${current.choices.map((choice) => `<button type="button" class="intensity-option ${chosen.includes(choice) ? "selected" : ""}" data-helper-answer="${choice}" aria-pressed="${chosen.includes(choice)}"><span><strong>${esc(current.id === "premium" ? { 0: "Zonder toeslag", 2: "Maximaal twee premium samples", 5: "Alle sampletypes" }[choice] : ht(current.id + "_" + choice))}</strong>${current.id === "premium" ? "" : `<small>${esc(ht(current.id + "_" + choice + "_sub"))}</small>`}</span></button>`).join("")}</div><div class="guide-footer"><button type="button" class="link" data-helper-back>${esc(helperStep ? ht("back") : "Zelf kiezen")}</button><button type="button" class="button" data-helper-next ${chosen.length ? "" : "disabled"}>${esc(helperStep === 4 ? ht("show_result") : ht("next"))}</button></div>`;
    }
    on(root, "click", (event) => {
      const b = event.target.closest("button");
      if (!b || busy) return;
      if (b.hasAttribute("data-help-open")) {
        helperActive = true;
        helperStep = 0;
        renderHelper();
        $("#review-button").disabled = true;
      }
      if (b.dataset.helperAnswer) {
        const current = helperSteps[helperStep],
          value = b.dataset.helperAnswer;
        if (current.multi) {
          let values = helperAnswers[current.id] || [];
          values =
            value === "any" ? ["any"] : values.filter((x) => x !== "any");
          if (value !== "any")
            values = values.includes(value)
              ? values.filter((x) => x !== value)
              : values.concat(value);
          helperAnswers[current.id] = values;
        } else helperAnswers[current.id] = value;
        renderHelper();
      }
      if (b.hasAttribute("data-helper-back")) {
        if (helperStep) {
          helperStep--;
          renderHelper();
        } else {
          helperActive = false;
          renderMode();
          renderSlots();
        }
      }
      if (b.hasAttribute("data-helper-next")) {
        if (
          ![helperAnswers[helperSteps[helperStep].id]].flat().filter(Boolean)
            .length
        )
          return;
        helperStep++;
        if (helperStep === 5)
          helperResult = window.OrnataSampleGuide.selectFive(
            helperProducts(),
            helperAnswers,
          );
        renderHelper();
        $(".choice-panel").scrollTop = 0;
      }
      if (b.dataset.helperSwap !== undefined) {
        const index = Number(b.dataset.helperSwap),
          replacement = window.OrnataSampleGuide.replacement(
            helperProducts(),
            helperAnswers,
            helperResult,
            index,
            [0, 1, 2, 3, 4, 5],
          );
        if (
          replacement &&
          data.price(
            {
              type: "self",
              ids: helperResult.map((p, i) =>
                i === index ? replacement.id : p.id,
              ),
            },
            response,
          )
        ) {
          helperResult[index] = replacement;
          renderHelper();
        } else notify(ht("no_alternative"));
      }
      if (b.hasAttribute("data-helper-use")) {
        const ids = helperResult.map((p) => p.id);
        if (!data.price({ type: "self", ids }, response)) {
          notify(ht("stock_changed"));
          return;
        }
        selected = ids;
        slotIds = [...ids];
        selectedSet = null;
        mode = "self";
        helperActive = false;
        review = false;
        renderMode();
        renderSlots();
        persist();
        $("#review-button").focus();
      }
    });

    let availableOnly = false;
    const atelier = $("#atelier"),
      content = $("#choice-content");
    function persist() {
      try {
        localStorage.setItem(
          storageKey,
          JSON.stringify({
            selected,
            slotIds,
            mode,
            guide,
            surprise,
            selectedSet,
            confirmedSet,
          }),
        );
      } catch {}
    }

    function notify(message) {
      const t = $("#toast");
      clearTimeout(toastTimer);
      const dialogs = all("dialog[open]");
      (dialogs.at(-1) || root).append(t);
      t.textContent = message;
      t.classList.add("visible");
      toastTimer = setTimeout(() => t.classList.remove("visible"), 5000);
    }

    function setProducts(s) {
      return s.ids.map(product).filter(Boolean);
    }
    function surcharge(ids = selected) {
      return ids.reduce(
        (sum, id) =>
          sum + Number(response?.byProductId?.[id]?.sampleSurchargeCents || 0),
        0,
      );
    }

    function draft() {
      return {
        type: mode,
        ids: [...selected],
        profile: mode === "guide" ? guide : surprise,
      };
    }
    function currentPrice() {
      return data.price(draft(), response, true)?.price ?? basePrice();
    }
    function basePrice() {
      return Number(
        response?.pricing?.variants?.find((v) => Number(v.surchargeCents) === 0)
          ?.price ?? config.basePrice,
      );
    }
    function available(p) {
      return (
        inventoryReady &&
        catalogReady &&
        response?.byProductId?.[p?.id]?.selectable === true
      );
    }
    function sampleLabel(p, compact = false) {
      const item = response?.byProductId?.[p.id];
      return !inventoryReady
        ? "Voorraad laden…"
        : !item?.selectable
          ? item?.storeExclusive
            ? "Alleen in de boutique"
            : "Tijdelijk niet beschikbaar"
          : item.sampleSurchargeCents > 0
            ? (item.sampleTypeName || "Premium") +
              " · +" +
              money(item.sampleSurchargeCents, compact)
            : "";
    }

    function displayItems() {
      if (mode === "guide" || mode === "surprise")
        return review
          ? Array.from({ length: 5 }, (_, i) => ({
              id: "personal-" + i,
              name: mode === "guide" ? "Voor jou" : "Verrassing",
            }))
          : [];
      return slottedProducts();
    }
    function renderSlots() {
      const personal = mode === "guide" || mode === "surprise",
        items = personal ? (review ? displayItems() : []) : slottedProducts();
      $("#selection-slots").innerHTML = Array.from({ length: 5 }, (_, i) => {
        const p = items[i];
        return `<div class="selection-slot ${p ? "" : "empty"}"><span class="slot-index">0${i + 1}</span>${p?.image ? `<img src="${esc(p.image)}" alt="">` : p ? '<span class="mystery-mini">?</span>' : ""}<span class="slot-name">${p ? esc(p.name) : "Kies een geur"}${p?.brand ? `<small>${esc(p.brand)}</small>` : ""}</span>${p && !personal ? `<button class="slot-remove" data-remove="${p.id}" aria-label="Verwijder ${esc(p.name)}">×</button>` : ""}</div>`;
      }).join("");
      $("#box-live-count").textContent = personal
        ? review
          ? "PERSOONLIJK VOOR JOU"
          : "DOOR ORNATA GEKOZEN"
        : `${selected.length} / 5 GEUREN`;
      $("#builder-price").textContent = money(currentPrice());
      const rb = $("#review-button");
      rb.disabled =
        !inventoryReady ||
        !catalogReady ||
        (!personal && selected.length !== 5) ||
        (personal && !review) ||
        !data.price(draft(), response);
      rb.innerHTML = `<span>${review ? "Set bevestigen" : personal ? "Jouw voorkeuren" : selected.length === 5 ? "Set bevestigen" : `Kies nog ${5 - selected.length} ${selected.length === 4 ? "geur" : "geuren"}`}</span>`;
      $("[data-clear-selection]").disabled = personal || !selected.length;
      builderModel?.setItems(items);
    }
    function updateModels() {
      builderModel?.setOpen(true);
      heroModel?.setItems(confirmedItems(), false);
    }

    function markMode() {
      all("[data-mode]").forEach((b) => {
        b.classList.toggle("active", b.dataset.mode === mode);
        b.setAttribute(
          "aria-current",
          b.dataset.mode === mode ? "page" : "false",
        );
      });
    }
    async function openAtelier(nextMode) {
      if (busy) return;
      heroModel?.closeInspection?.(true, false);
      helperActive = false;
      mode = nextMode;
      review = false;
      search = "";
      filter = "Alle";
      step = 0;
      renderMode();
      renderSlots();
      if (!atelier.open) atelier.showModal();
      $(".choice-panel").scrollTop = 0;
      persist();
      if (config.enable3d && !builderPromise) {
        builderPromise = createBox($("#builder-stage"), {
          compact: true,
          orientation: "left",
          mobileOrientation: "front",
          items: displayItems(),
        });
        builderPromise.then((model) => {
          if (disposed) {
            model.dispose();
            return;
          }
          builderModel = model;
          renderSlots();
          updateModels();
          model.resize();
        });
      } else {
        updateModels();
        builderModel?.resize();
      }
      requestAnimationFrame(() => {
        content.querySelector("input,button")?.focus({ preventScroll: true });
      });
    }
    function switchMode(nextMode) {
      if (busy) return;
      helperActive = false;
      mode = nextMode;
      review = false;
      step = 0;
      renderMode();
      renderSlots();
      updateModels();
      persist();
      $(".choice-panel").scrollTop = 0;
    }
    function renderMode() {
      markMode();
      if (helperActive) {
        renderHelper();
        return;
      }
      if (review) {
        renderReview();
        return;
      }
      if (mode === "self") renderSelf();
      if (mode === "sets") renderSets();
      if (mode === "guide") renderGuide();
      if (mode === "surprise") renderSurprise();
      labelFields();
    }
    function labelFields() {
      for (const name of ["guide-notes", "surprise-notes"]) {
        const field = $("#" + name);
        if (field) {
          field.id = config.sectionId + "-" + name;
          const label = content.querySelector('label[for="' + name + '"]');
          if (label) label.htmlFor = field.id;
        }
      }
    }
    function renderSelf() {
      content.innerHTML = `<div class="choice-heading"><div><h2 data-at="atelier-title">Zelf samenstellen</h2><p>Kies vijf geuren. Eén klik geeft een sample een plek in je set.</p></div><button class="link" data-help-open>Help mij kiezen</button></div><div class="catalog-toolbar"><label class="search-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><circle cx="10" cy="10" r="6"/><path d="m15 15 5 5"/></svg><input data-at="perfume-search" type="search" placeholder="Zoek op geur, merk of geurnoot" aria-label="Zoek op geur, merk of geurnoot" value="${esc(search)}"></label><label class="sort-label">Sorteren <select data-at="perfume-sort"><option value="default">Standaard</option><option value="name">Naam A–Z</option><option value="brand">Merk A–Z</option><option value="included">Zonder toeslag eerst</option><option value="popular">Meest gekozen</option></select></label></div><label class="available-filter"><input type="checkbox" data-available-only ${availableOnly ? "checked" : ""}> Alleen beschikbare samples</label><div class="filter-row" aria-label="Filter op geurfamilie">${["Alle", ...families.map((f) => f[0])].map((f) => `<button class="filter-button ${filter === f ? "active" : ""}" data-filter="${f}" aria-pressed="${filter === f}">${f}</button>`).join("")}</div><div class="catalog-status"><span class="count-tag"></span><span>5 × 2 ml · vanaf ${money(basePrice())}</span></div><div class="perfume-grid" data-at="perfume-grid"></div>`;
      $("#perfume-sort").value = sort;
      renderGrid();
    }
    function renderGrid() {
      const q = search.trim().toLocaleLowerCase("nl");
      const activeSet = sets.find((x) => x.id === selectedSet && x.custom);
      const filtered = catalog.filter(
        (p) =>
          (!activeSet || activeSet.ids.includes(p.id)) &&
          (!availableOnly || available(p)) &&
          (filter === "Alle" || p.families.includes(filter)) &&
          [
            p.name,
            p.brand,
            ...p.families,
            ...Object.values(p.notes || {}).flat(),
          ]
            .join(" ")
            .toLocaleLowerCase("nl")
            .includes(q),
      );
      if (sort === "name")
        filtered.sort((a, b) => a.name.localeCompare(b.name, "nl"));
      if (sort === "brand")
        filtered.sort(
          (a, b) =>
            a.brand.localeCompare(b.brand, "nl") ||
            a.name.localeCompare(b.name, "nl"),
        );
      if (sort === "included")
        filtered.sort((a, b) => surcharge([a.id]) - surcharge([b.id]));
      if (sort === "popular")
        filtered.sort(
          (a, b) =>
            Number(response?.byProductId?.[b.id]?.choiceCount || 0) -
            Number(response?.byProductId?.[a.id]?.choiceCount || 0),
        );
      $("#perfume-grid").innerHTML = filtered.length
        ? filtered
            .map((p) => {
              const store =
                response?.byProductId?.[p.id]?.storeExclusive === true;
              const unavailable = inventoryReady && !store && !available(p);
              const panelId = config.sectionId + "-store-" + p.id;
              return `<article class="perfume-card${store ? " is-store" : unavailable ? " is-unavailable" : ""}" data-card="${p.id}" data-orn-sample-db-card="${p.id}" data-orn-sample-db-kind="atelier">${store ? '<span class="store-badge">Store exclusive</span>' : unavailable ? '<span class="stock-badge">Niet beschikbaar</span>' : ""}<button type="button" class="perfume-select" ${store ? `data-store-preview aria-controls="${panelId}" aria-label="${esc(p.name)}: alleen in de boutique"` : `data-add="${p.id}" aria-pressed="false"`}><span class="perfume-image-button"><img src="${esc(p.image)}" alt="" loading="lazy"></span><span class="perfume-brand">${esc(p.brand)}</span><span class="perfume-name">${esc(p.name)}</span><span class="perfume-family">${esc(p.families.slice(0, 3).join(" · "))}</span><span class="perfume-card-bottom"><span class="perfume-surcharge">${store || unavailable ? "" : esc(sampleLabel(p, true))}</span>${store ? "" : '<span class="perfume-add" aria-hidden="true"><svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.2"><path data-add-symbol d="M3 7h8M7 3v8"/></svg></span>'}</span></button><button type="button" class="perfume-info" data-detail="${p.id}" aria-label="Geurdetails ${esc(p.name)}">i</button>${store ? `<div class="store-panel" id="${panelId}" data-store-panel><b>Store exclusive</b><span>Deze geur is exclusief in onze boutique te ruiken.</span><a href="/pages/boutique" class="link">Afspraak plannen</a></div>` : ""}</article>`;
            })
            .join("")
        : `<div class="empty-results"><h3>Geen geuren gevonden</h3><p>Probeer een andere geur, noot of geurfamilie.</p><button class="link atelier-text-link" data-clear-search>Toon alle geuren </button></div>`;
      const tag = $(".count-tag");
      if (tag)
        tag.textContent = `${filtered.length} ${filtered.length === 1 ? "geur" : "geuren"}`;
      syncCards();
      if (response)
        root.dispatchEvent(
          new CustomEvent("ornata:sample-catalog-rendered", {
            detail: response,
          }),
        );
    }
    function syncCards() {
      all("[data-card]").forEach((card) => {
        const id = card.dataset.card,
          chosen = selected.includes(id),
          b = card.querySelector("[data-add]");
        if (!b) return;
        card.classList.toggle("selected", chosen);
        b.setAttribute("aria-pressed", chosen);
        b.setAttribute(
          "aria-label",
          `${chosen ? "Verwijder" : "Voeg toe:"} ${product(id).name}`,
        );
        b.disabled =
          !available(product(id)) || (!chosen && selected.length === 5);
        card
          .querySelector("[data-add-symbol]")
          .setAttribute("d", chosen ? "m3 7 2.5 2.5L11 4" : "M3 7h8M7 3v8");
      });
    }
    function toggleProduct(id) {
      if (!product(id) || (!selected.includes(id) && !available(product(id))))
        return;
      const i = selected.indexOf(id);
      if (i >= 0) selected.splice(i, 1);
      else {
        if (selected.length === 5) {
          notify(
            "Je set is compleet. Verwijder eerst een geur om te wisselen.",
          );
          return;
        }
        selected.push(id);
      }
      if (!sets.find((x) => x.id === selectedSet)?.custom) selectedSet = null;
      syncSlotIds();
      persist();
      renderSlots();
      if (mode === "self" && !review) syncCards();
      if (review) renderReview();
    }
    function showDetail(id) {
      const p = product(id);
      if (!p) return;
      const chosen = selected.includes(id);
      $("#detail-content").innerHTML =
        `<div class="detail-inner"><div class="detail-image"><img src="${esc(p.image)}" alt="${esc(p.name)}"></div><div class="detail-copy"><div class="detail-heading"><p class="eyebrow">${esc(p.brand)}</p><h2 data-at="detail-title">${esc(p.name)}</h2><p>${esc(p.families.join(" · "))}</p></div><dl class="note-pyramid">${[
          ["top", "Topnoten"],
          ["heart", "Hartnoten"],
          ["base", "Basisnoten"],
        ]
          .map(
            ([key, title]) =>
              `<div><dt>${title}</dt><dd>${esc(p.notes?.[key]?.join(", ") || "Ontdek het op je huid")}</dd></div>`,
          )
          .join(
            "",
          )}</dl><div class="detail-actions"><p>2 ml sample${sampleLabel(p) ? " · " + esc(sampleLabel(p)) : ""}</p><button class="button" data-detail-add="${id}" ${!available(p) || (!chosen && selected.length === 5) ? "disabled" : ""}><span>${chosen ? "Verwijder uit set" : selected.length === 5 ? "Je set is compleet" : "Toevoegen aan set"}</span><span aria-hidden="true">${chosen ? "−" : "+"}</span></button></div></div></div>`;
      $("#product-detail").showModal();
    }
    function setArtwork(s) {
      const ps = setProducts(s);
      return `<div class="set-art"><span class="set-art-label">${esc(s.name)}</span>${ps
        .slice(0, 5)
        .map(
          (p) =>
            `<img src="${esc(p.image)}" alt="${esc(p.name)}" loading="lazy" width="200" height="240">`,
        )
        .join("")}</div>`;
    }
    function setReady(s) {
      return (
        inventoryReady &&
        catalogReady &&
        (s.custom
          ? s.ids.filter((id) => available(product(id))).length >= 5
          : s.ids.length === 5 &&
            s.ids.every((id) => available(product(id))) &&
            !!data.price({ type: "sets", ids: s.ids }, response))
      );
    }
    function setPrice(s) {
      return s.custom
        ? "Kies vijf geuren"
        : money(
            data.price({ type: "sets", ids: s.ids }, response)?.price ??
              basePrice() + surcharge(s.ids),
          );
    }

    function renderHomeSets() {
      const el = $("#home-sets");
      if (el)
        el.innerHTML =
          sets
            .slice(0, config.homeSetLimit || 3)
            .map(
              (s, i) =>
                `<button type="button" class="set-tile" data-home-set="${esc(s.id)}" ${setReady(s) ? "" : "disabled"}>${setArtwork(s)}<div class="set-tile-meta"><h3>${esc(s.name)}</h3></div><p>${setReady(s) ? setPrice(s) : "Tijdelijk niet beschikbaar"}</p></button>`,
            )
            .join("") ||
          "<p>Er zijn op dit moment geen complete sets beschikbaar.</p>";
    }

    function renderSets() {
      content.innerHTML = `<div class="choice-heading"><div><h2 data-at="atelier-title">Complete sets</h2><p>Kies een vaste selectie of stel vijf geuren samen uit een merkset.</p></div></div><div class="set-picker-list">${sets.map((s, i) => `<article class="set-picker">${setArtwork(s)}<div class="set-picker-body"><h3>${esc(s.name)}</h3><p>${esc(s.description)}</p><button type="button" class="button" data-choose-set="${esc(s.id)}" ${setReady(s) ? "" : "disabled"}><span>${setReady(s) ? (s.custom ? "Kies vijf geuren uit deze set" : "Kies deze set · " + setPrice(s)) : "Tijdelijk niet beschikbaar"}</span></button></div></article>`).join("") || "<p>Er zijn op dit moment geen complete sets beschikbaar.</p>"}</div>`;
    }

    function chooseSet(id) {
      const s = sets.find((x) => x.id === id);
      if (!s || !setReady(s)) return;
      selectedSet = s.id;
      if (s.custom) {
        selected = [];
        slotIds = Array(5).fill(null);
        mode = "self";
        review = false;
      } else {
        selected = [...s.ids];
        slotIds = [...s.ids];
        review = true;
        mode = "sets";
      }
      renderSlots();
      renderMode();
      updateModels();
      persist();
      $(".choice-panel").scrollTop = 0;
    }

    function renderGuide() {
      const headings = [
        "Welke geurfamilies spreken je aan?",
        "Hoe aanwezig mag je geur zijn?",
        "Mogen er premium samples bij?",
        "Wat wil je ons meegeven?",
      ];
      const descriptions = [
        "Kies één tot drie geurfamilies die je aanspreken.",
        "Kies één of meerdere opties. Zo kunnen we verschillende soorten geuren voor je selecteren.",
        "Kies het sampletype en de toeslag die bij je passen. Maximaal drie premium samples.",
        "Noem bijvoorbeeld favoriete parfums of geurnoten die je liever vermijdt.",
      ];
      let inner = "";
      if (step === 0)
        inner = `<div class="family-options">${families.map(([name, sub, a, b]) => `<button class="family-option" data-family="${name}" aria-pressed="${guide.families.includes(name)}" ${guide.families.length >= 3 && !guide.families.includes(name) ? "disabled" : ""}><span class="family-orb" style="--orb1:${a};--orb2:${b}"></span><span><strong>${name}</strong><small>${sub}</small></span>${guide.families.includes(name) ? '<span class="choice-check">✓</span>' : ""}</button>`).join("")}</div>`;
      if (step === 1)
        inner = `<div class="intensity-options">${[
          ["Licht en fris", "Een subtiele geur, dicht op je huid.", "○ ○ ●"],
          [
            "Ergens in het midden",
            "Aanwezig, zonder de ruimte over te nemen.",
            "○ ● ●",
          ],
          ["Zwaar en vol", "Een geur met een duidelijke signatuur.", "● ● ●"],
        ]
          .map(
            ([name, sub, dots]) =>
              `<button class="intensity-option ${data.list(guide.intensity).includes(name) ? "selected" : ""}" data-intensity="${name}" aria-pressed="${data.list(guide.intensity).includes(name)}"><span><strong>${name}</strong><small>${sub}</small></span><span class="intensity-dots">${dots}</span></button>`,
          )
          .join("")}</div>`;
      if (step === 2) inner = premiumButtons("guide");
      if (step === 3)
        inner = `<label class="note-label" for="guide-notes">Jouw persoonlijke noot <span>(optioneel)</span></label><textarea class="note-input" data-at="guide-notes" maxlength="500" placeholder="Ik hou van zacht hout en vanille, maar liever niet te zoet…">${esc(guide.notes)}</textarea><p class="quiet-note">Ornata gebruikt jouw voorkeuren om vijf geuren voor je te kiezen.</p>`;
      content.innerHTML = `<div class="guide-progress" aria-label="Stap ${step + 1} van 4">${[0, 1, 2, 3].map((i) => `<span class="${i <= step ? "done" : ""}"></span>`).join("")}</div><p class="eyebrow guide-eyebrow">${String(step + 1).padStart(2, "0")} / 04</p><div class="choice-heading"><h2 data-at="atelier-title">${headings[step]}</h2></div><p class="guide-intro">${descriptions[step]}</p>${inner}<div class="guide-footer"><button class="link" data-guide-back>${step ? " Vorige" : " Zelf kiezen"}</button><button class="button" data-guide-next ${(step === 0 && !guide.families.length) || (step === 1 && !data.list(guide.intensity).length) ? "disabled" : ""}><span>${step === 3 ? "Bevestig voorkeuren" : "Verder"}</span></button></div>`;
    }
    function premiumButtons(type) {
      const profile = type === "guide" ? guide : surprise,
        offered = data.choices(response),
        total = Object.values(profile.types || {}).reduce((a, b) => a + b, 0);
      return `<div class="sample-type-options">${
        offered
          .map((c) => {
            const n = profile.types?.[c.id] || 0;
            return `<div class="sample-type-choice"><span>${esc(c.name)}<small>+${money(c.surchargeCents)} per sample</small></span><div class="quantity-selector premium-counter" role="group" aria-label="Aantal ${esc(c.name)} samples"><button type="button" class="quantity-selector__button" data-premium-step="-1" data-sample-type="${esc(c.id)}" data-for="${type}" aria-label="Eén ${esc(c.name)} sample minder" ${n === 0 ? "disabled" : ""}><svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true"><path d="M2 6h8" fill="none" stroke="currentColor"/></svg></button><output class="premium-quantity" aria-live="polite">${n}</output><button type="button" class="quantity-selector__button" data-premium-step="1" data-sample-type="${esc(c.id)}" data-for="${type}" aria-label="Eén ${esc(c.name)} sample meer" ${total >= 3 ? "disabled" : ""}><svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true"><path d="M2 6h8M6 2v8" fill="none" stroke="currentColor"/></svg></button></div></div>`;
          })
          .join("") ||
        "<p>Er zijn momenteel geen premium samples beschikbaar.</p>"
      }</div><p class="quiet-note">${esc(data.typeSummary(profile, response, money) || "Zonder toeslag")}</p>`;
    }

    function renderSurprise() {
      content.innerHTML = `<p class="eyebrow guide-eyebrow">DOOR ORNATA GEKOZEN</p><div class="choice-heading"><h2 data-at="atelier-title">Laat je verrassen.</h2></div><p class="guide-intro">Wij kiezen vijf parfums voor je. Hieronder kun je aangeven wat je liever niet wilt en of je premium samples wilt toevoegen.</p><div class="surprise-visual" aria-hidden="true">${[-9, 5, -3, 7, -6].map((v, i) => `<span class="mystery-vial" style="--tilt:${v}deg;--y:${i % 2 ? -5 : 9}px"></span>`).join("")}</div><label class="note-label" for="surprise-notes">Een kleine aanwijzing? <span>(optioneel)</span></label><textarea data-at="surprise-notes" class="note-input" maxlength="500" placeholder="Verras me, maar liever geen hele zware geuren…">${esc(surprise.notes)}</textarea><div class="surprise-options"><h3>Wil je premium samples?</h3><p>Kies maximaal drie premium samples. De toeslag staat per sampletype vermeld.</p>${premiumButtons("surprise")}</div><button class="button surprise-submit" data-surprise-next><span>Laat me verrassen · ${money(currentPrice())}</span></button>`;
    }
    function confirmedItems() {
      if (!confirmedSet)
        return Array.from({ length: 5 }, (_, i) => ({
          id: "display-" + i,
          name: "Ornata sample",
        }));
      return ["guide", "surprise"].includes(confirmedSet.type)
        ? Array.from({ length: 5 }, (_, i) => ({
            id: "personal-" + i,
            name: "Door Ornata gekozen",
          }))
        : (confirmedSet.slotIds || confirmedSet.ids).map(
            (id) => product(id) || null,
          );
    }

    function renderHomeSummary() {
      const el = $("#home-selection");
      el.hidden = !confirmedSet;
      $("#home-cta").textContent = busy
        ? "Even geduld…"
        : confirmedSet
          ? config.cartLabel
          : config.startLabel;
      $("#home-cta").disabled =
        busy ||
        !inventoryReady ||
        !catalogReady ||
        (confirmedSet &&
          !data.properties(confirmedSet, response, catalog, money));
      $("#home-price").textContent = money(
        confirmedSet
          ? (data.price(confirmedSet, response)?.price ?? basePrice())
          : basePrice(),
        true,
      );
      if (!confirmedSet) {
        el.innerHTML = "";
        return;
      }
      const c = confirmedSet,
        personal = ["guide", "surprise"].includes(c.type);
      el.innerHTML = `<div class="home-selection-heading"><span>${esc(c.name || "Jouw samengestelde set")}</span><div class="home-selection-actions"><button class="link" data-edit-home>Aanpassen</button><button class="link" data-remove-home>Verwijderen</button></div></div>${
        personal
          ? `<p class="home-profile">Ornata kiest vijf geuren voor je.${c.profile?.families?.length ? `<br>${esc(c.profile.families.join(" · "))}` : ""}${data.list(c.profile?.intensity).length ? ` · ${esc(data.list(c.profile.intensity).join(" · "))}` : ""}<br>${esc(data.typeSummary(c.profile, response, money) || "Zonder premium toeslag")}</p>`
          : `<div class="home-selection-list">${c.ids
              .map(product)
              .filter(Boolean)
              .map(
                (p) =>
                  `<div><img src="${esc(p.image)}" alt=""><span>${esc(p.name)}<small>${esc(p.brand)} · 2 ml</small></span></div>`,
              )
              .join("")}</div>`
      }`;
    }
    function startReview() {
      if (!inventoryReady || !catalogReady || !data.price(draft(), response)) {
        notify(
          "Controleer je selectie: een sample of prijs is niet meer beschikbaar.",
        );
        return;
      }
      const personal = mode === "guide" || mode === "surprise";
      if (!personal && selected.length !== 5) {
        notify("Kies vijf geuren om je set compleet te maken.");
        return;
      }
      syncSlotIds();
      const chosenSet = sets.find((s) => s.id === selectedSet);
      confirmedSet = {
        type: chosenSet ? "sets" : mode,
        name: personal
          ? mode === "guide"
            ? "Door Ornata"
            : "Verras me"
          : sets.find((s) => s.id === selectedSet)?.name ||
            "Jouw persoonlijke selectie",
        ids: personal ? [] : slotIds.filter(Boolean),
        slotIds: personal ? [] : [...slotIds],
        profile: personal
          ? JSON.parse(JSON.stringify(mode === "guide" ? guide : surprise))
          : null,
        selectedSet,
        customSet: chosenSet?.custom === true,
      };
      persist();
      writeForm();
      renderHomeSummary();
      atelier.close();
      heroModel?.setItems(confirmedItems(), false);
      heroModel?.setOpen(true);
      $(".hero-copy").scrollIntoView({
        behavior: matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "instant"
          : "smooth",
        block: "start",
      });
      $("#home-cta").focus({ preventScroll: true });
    }
    function editHome() {
      if (!confirmedSet) return;
      const c = confirmedSet;
      selected = c.ids.filter((id) => available(product(id)));
      slotIds =
        c.slotIds?.length === 5
          ? [...c.slotIds]
          : Array.from({ length: 5 }, (_, i) => selected[i] || null);
      if (c.type === "guide") guide = JSON.parse(JSON.stringify(c.profile));
      if (c.type === "surprise")
        surprise = JSON.parse(JSON.stringify(c.profile));
      selectedSet = c.selectedSet;
      openAtelier(c.customSet ? "self" : c.type);
    }
    function renderReview() {
      const personal = mode === "guide" || mode === "surprise";
      const s = sets.find((x) => x.id === selectedSet);
      const intro = personal
        ? mode === "guide"
          ? "Jouw voorkeuren"
          : "Jouw verrassingsset"
        : "Jouw set is compleet.";
      content.innerHTML = `<div class="review-intro"><p class="eyebrow">${s && !personal ? esc(s.name.toUpperCase()) : "JOUW SAMPLE SET"}</p><h2 data-at="atelier-title" style="margin-top:20px">${intro}</h2><p>${personal ? "Ornata kiest vijf geuren op basis van de voorkeuren hieronder." : "Controleer je vijf geuren en bevestig je set."}</p></div>${
        personal
          ? profileSummary()
          : `<div class="review-list">${selected
              .map((id, i) => {
                const p = product(id);
                return `<div class="review-item"><img src="${esc(p.image)}" alt="${esc(p.name)}"><div>${esc(p.name)}<small>${esc(p.brand)} · 2 ml</small></div><span>${esc(sampleLabel(p))}</span></div>`;
              })
              .join("")}</div>`
      }<button class="link atelier-text-link" data-edit-selection>${personal ? "Pas mijn voorkeuren aan" : "Pas mijn selectie aan"} </button><div class="price-breakdown"><div><span>Ornata sample set · 5 × 2 ml</span><span>${money(basePrice())}</span></div><div><span>Premium samples</span><span>${money(currentPrice() - basePrice())}</span></div><div><span>Verzending</span><span>Gratis</span></div><div class="total"><span>Jouw totaal</span><span>${money(currentPrice())}</span></div></div><button class="button review-submit" data-add-cart><span>Bevestig deze set</span></button>`;
    }
    function profileSummary() {
      const obj = mode === "guide" ? guide : surprise;
      return `<div class="profile-summary"><h3>${mode === "guide" ? "Jouw geurprofiel" : "Een verrassing met aandacht"}</h3>${mode === "guide" ? `<p><b>Geurfamilies</b> · ${esc(guide.families.join(", "))}</p><p><b>Intensiteit</b> · ${esc(data.list(guide.intensity).join(", "))}</p>` : ""}<p><b>Premium</b> · ${esc(data.typeSummary(obj, response, money) || "Zonder toeslag")}</p>${obj.notes ? `<p><b>Jouw persoonlijke noot</b></p><blockquote>“${esc(obj.notes)}”</blockquote>` : ""}<p>De vijf geuren worden door Ornata uitgekozen.</p></div>`;
    }
    async function addToCart() {
      if (busy || !confirmedSet || !inventoryReady || !catalogReady) return;
      const selection = data.clone(confirmedSet),
        previous = data.properties(selection, response, catalog, money);
      if (!previous) return;
      busy = true;
      renderHomeSummary();
      let added = false;
      try {
        await window.OrnataSampleInventory.refresh(root);
        if (disposed) return;
        const current = data.properties(selection, response, catalog, money);
        if (!inventoryReady || !current)
          throw new Error(
            "Een sample is niet meer beschikbaar. Pas je selectie aan.",
          );
        if (
          current.variantId !== previous.variantId ||
          current.price !== previous.price ||
          current.surcharge !== previous.surcharge
        )
          throw new Error(
            "De sampleprijs is gewijzigd. Controleer het nieuwe totaal en klik opnieuw op In winkelmand.",
          );
        if (!config.canPurchase)
          throw new Error("Deze sample service is momenteel niet beschikbaar.");
        writeForm(selection);
        const fields = new FormData(form),
          sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:prepare-bundled-sections", {
            bubbles: true,
            detail: { sections },
          }),
        );
        fields.set("sections", sections.join(","));
        fields.set("sections_url", window.location.pathname);
        const routes = window.Shopify?.routes?.root || "/";
        const result = await fetch(routes + "cart/add.js", {
          method: "POST",
          body: fields,
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        const resultJson = await result.json();
        if (!result.ok)
          throw new Error(
            resultJson.description ||
              "Toevoegen lukt niet. Probeer het opnieuw.",
          );
        added = true;
        if (window.themeVariables?.settings?.cartType === "page") {
          window.location.assign(routes + "cart");
          return;
        }
        const cartResponse = await fetch(routes + "cart.js");
        if (!cartResponse.ok) throw new Error("Cart refresh failed");
        const cart = await cartResponse.json();
        cart.sections = resultJson.sections;
        form.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              items: resultJson.items || [resultJson],
              cart,
              onSuccessDo: "force_open_drawer",
            },
          }),
        );
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              onSuccessDo: "force_open_drawer",
              cart,
            },
          }),
        );
        setNotice("");
      } catch (error) {
        if (disposed) return;
        if (added) {
          setNotice("Open je winkelmand om verder te gaan.");
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        } else
          setNotice(
            error.message ||
              "Toevoegen lukt tijdelijk niet. Probeer het opnieuw.",
          );
      } finally {
        busy = false;
        if (!disposed) {
          renderHomeSummary();
          writeForm();
        }
      }
    }
    function writeForm(selection = confirmedSet) {
      form
        .querySelectorAll("[data-sample-property]")
        .forEach((n) => n.remove());
      const value = data.properties(selection, response, catalog, money),
        id = form.querySelector('[name="id"]');
      id.value = value?.variantId || "";
      id.disabled = !value;
      if (value)
        for (const [name, text] of Object.entries(value.properties)) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = "properties[" + name + "]";
          input.value = text;
          input.dataset.sampleProperty = "";
          form.append(input);
        }
    }
    function setNotice(message) {
      const el = $("[data-service-notice]");
      el.textContent = message || "";
      el.hidden = !message;
    }

    // Touch devices need the same first-tap reveal as the original hover card.
    on(document, "pointerdown", (e) => {
      all(".is-store-open").forEach((card) => {
        if (card.contains(e.target)) return;
        card.classList.remove("is-store-open");
        card
          .querySelector("[data-store-preview]")
          ?.setAttribute("aria-expanded", "false");
        if (card.contains(document.activeElement))
          document.activeElement.blur();
      });
    });
    on(root, "click", (e) => {
      const b = e.target.closest("button");
      if (!b || b.disabled || busy || !root.contains(b)) return;
      if (
        b.hasAttribute("data-store-preview") &&
        matchMedia("(hover: none), (pointer: coarse)").matches
      ) {
        b.closest(".is-store").classList.add("is-store-open");
        b.setAttribute("aria-expanded", "true");
      }
      if (b.dataset.premiumStep) {
        const id = b.dataset.sampleType;
        if (!data.choices(response).some((choice) => String(choice.id) === id))
          return;
        const profile = b.dataset.for === "guide" ? guide : surprise;
        const current = Number(profile.types[id] || 0);
        const total = Object.values(profile.types).reduce(
          (sum, n) => sum + n,
          0,
        );
        const next = current + Number(b.dataset.premiumStep);
        if (next < 0 || total + next - current > 3) return;
        profile.types[id] = next;
        const buttonIndex = all("[data-premium-step]").indexOf(b);
        renderMode();
        renderSlots();
        persist();
        const buttons = all("[data-premium-step]");
        const target = buttons[buttonIndex];
        (target?.disabled ? buttons[buttonIndex ^ 1] : target)?.focus({
          preventScroll: true,
        });
      }
      if (b.dataset.close) {
        $("#" + b.dataset.close).close();
        if (b.dataset.close === "atelier") persist();
      }
      if (b.dataset.start) openAtelier(b.dataset.start);
      if (b.dataset.mode) switchMode(b.dataset.mode);
      if (b.dataset.filter) {
        filter = b.dataset.filter;
        all("[data-filter]").forEach((x) => {
          x.classList.toggle("active", x.dataset.filter === filter);
          x.setAttribute("aria-pressed", x.dataset.filter === filter);
        });
        renderGrid();
      }
      if (b.hasAttribute("data-clear-search")) {
        filter = "Alle";
        search = "";
        renderSelf();
        $("#perfume-search").focus();
      }
      if (b.dataset.add) {
        toggleProduct(b.dataset.add);
      }
      if (b.dataset.remove) {
        const rebuild = review || mode !== "self";
        mode = "self";
        review = false;
        toggleProduct(b.dataset.remove);
        if (rebuild) renderMode();
        markMode();
      }
      if (b.hasAttribute("data-clear-selection")) {
        selected = [];
        slotIds = Array(5).fill(null);
        selectedSet = null;
        review = false;
        persist();
        renderSlots();
        if (mode === "self") syncCards();
        else {
          mode = "self";
          renderMode();
        }
        updateModels();
      }
      if (b.dataset.detail) showDetail(b.dataset.detail);
      if (b.dataset.detailAdd) {
        toggleProduct(b.dataset.detailAdd);
        $("#product-detail").close();
      }
      if (b.dataset.homeSet) {
        openAtelier("sets");
        chooseSet(b.dataset.homeSet);
      }
      if (b.dataset.chooseSet) chooseSet(b.dataset.chooseSet);
      if (b.dataset.family) {
        const f = b.dataset.family;
        const i = guide.families.indexOf(f);
        if (i >= 0) guide.families.splice(i, 1);
        else if (guide.families.length < 3) guide.families.push(f);
        else return;
        renderGuide();
        persist();
        $(`[data-family="${f}"]`)?.focus({ preventScroll: true });
      }
      if (b.dataset.intensity) {
        const value = b.dataset.intensity;
        const chosen = data.list(guide.intensity);
        guide.intensity = chosen.includes(value)
          ? chosen.filter((item) => item !== value)
          : chosen.concat(value);
        renderGuide();
        persist();
        $(`[data-intensity="${value}"]`)?.focus({
          preventScroll: true,
        });
      }
      if (b.hasAttribute("data-guide-next")) {
        if (
          (step === 0 && !guide.families.length) ||
          (step === 1 && !data.list(guide.intensity).length)
        )
          return;
        if (step < 3) {
          step++;
          renderGuide();
          labelFields();
          $(".choice-panel").scrollTop = 0;
        } else startReview();
      }
      if (b.hasAttribute("data-guide-back")) {
        if (step) {
          step--;
          renderGuide();
          labelFields();
          $(".choice-panel").scrollTop = 0;
        } else switchMode("self");
      }
      if (b.hasAttribute("data-surprise-next")) startReview();
      if (b.hasAttribute("data-edit-selection")) {
        review = false;
        if (mode === "sets") {
          mode = "self";
          if (!sets.find((s) => s.id === selectedSet)?.custom)
            selectedSet = null;
        }
        renderMode();
        renderSlots();
        updateModels();
        $(".choice-panel").scrollTop = 0;
      }
      if (b.hasAttribute("data-add-cart")) startReview();
      if (b.hasAttribute("data-edit-home")) editHome();
      if (b.hasAttribute("data-remove-home")) {
        confirmedSet = null;
        writeForm(null);
        setNotice("");
        selected = [];
        slotIds = Array(5).fill(null);
        selectedSet = null;
        mode = "self";
        review = false;
        persist();
        renderHomeSummary();
        heroModel?.setItems(confirmedItems(), false);
        $("#home-cta").focus({ preventScroll: true });
      }
    });
    on(root, "input", (e) => {
      if (e.target.dataset.at === "perfume-search") {
        search = e.target.value;
        renderGrid();
      }
      if (e.target.dataset.at === "guide-notes") {
        guide.notes = e.target.value;
        persist();
      }
      if (e.target.dataset.at === "surprise-notes") {
        surprise.notes = e.target.value;
        persist();
      }
    });
    on(root, "change", (e) => {
      if (e.target.hasAttribute("data-available-only")) {
        availableOnly = e.target.checked;
        renderGrid();
      }
      if (e.target.dataset.at === "perfume-sort") {
        sort = e.target.value;
        renderGrid();
      }
    });
    on($("#review-button"), "click", startReview);
    on($("#home-cta"), "click", () =>
      confirmedSet ? addToCart() : openAtelier("self"),
    );
    all("dialog").forEach((d) =>
      on(d, "click", (e) => {
        if (e.target !== d || d === atelier) return;
        const r = d.getBoundingClientRect();
        if (
          e.clientX < r.left ||
          e.clientX > r.right ||
          e.clientY < r.top ||
          e.clientY > r.bottom
        )
          d.close();
      }),
    );
    on(atelier, "close", () => {
      builderModel?.closeInspection?.(true, false);
      persist();
      heroModel?.setItems(confirmedItems(), false);
      heroModel?.resize();
    });
    all(".faq-list details").forEach((details, index) => {
      const summary = details.querySelector("summary"),
        answer = details.querySelector(".faq-answer");
      let animation = null,
        wanted = details.open;
      answer.id = "faq-answer-" + config.sectionId + "-" + index;
      summary.setAttribute("aria-controls", answer.id);
      summary.setAttribute("aria-expanded", wanted);
      details.dataset.expanded = String(wanted);
      on(summary, "click", (event) => {
        event.preventDefault();
        const start = details.getBoundingClientRect().height;
        if (animation) {
          animation.onfinish = null;
          animations.delete(animation);
          animation.cancel();
        }
        wanted = !wanted;
        summary.setAttribute("aria-expanded", wanted);
        details.dataset.expanded = String(wanted);
        summary.querySelector("span").textContent = wanted ? "−" : "+";
        if (matchMedia("(prefers-reduced-motion: reduce)").matches) {
          details.open = wanted;
          details.style.height = "";
          details.dataset.animating = "false";
          return;
        }
        details.style.height = start + "px";
        details.open = true;
        const collapsed = summary.getBoundingClientRect().height + 1,
          end =
            collapsed + (wanted ? answer.getBoundingClientRect().height : 0);
        details.dataset.animating = "true";
        animation = details.animate(
          [{ height: start + "px" }, { height: end + "px" }],
          { duration: 380, easing: "cubic-bezier(.22,1,.36,1)" },
        );
        animations.add(animation);
        animation.onfinish = () => {
          animations.delete(animation);
          details.open = wanted;
          details.style.height = "";
          details.dataset.animating = "false";
          animation = null;
        };
      });
    });
    function hydrate(next) {
      if (disposed) return;
      response = next;
      inventoryReady =
        root.getAttribute("data-orn-sample-inventory-state") === "ready";
      for (const set of next.completeSets || [])
        mergeCatalog(set.products || []);
      sets = (next.completeSets || []).map((s) => ({
        id: String(s.id),
        name: String(s.title || ""),
        description: String(s.description || ""),
        custom: s.selectionMode === "choose_five" || s.products?.length > 5,
        ids: (s.products || []).map((p) => String(p.productId)),
      }));
      renderHomeSets();
      renderHomeSummary();
      writeForm();
      if (atelier.open) {
        renderMode();
        renderSlots();
      }
      if (
        confirmedSet &&
        !data.properties(confirmedSet, response, catalog, money)
      )
        setNotice(
          "Je selectie is niet meer volledig beschikbaar. Klik op Aanpassen om je set bij te werken.",
        );
    }
    on(root, "ornata:sample-inventory-ready", (event) => hydrate(event.detail));
    on(root, "ornata:sample-inventory-error", () => {
      inventoryReady = false;
      renderHomeSummary();
      setNotice(
        "De actuele voorraad en prijzen kunnen niet worden geladen. Probeer het opnieuw.",
      );
    });
    on(form, "submit", (event) => {
      event.preventDefault();
      addToCart();
    });
    on(root, "click", (event) => {
      if (event.target.closest("[data-inventory-retry]"))
        window.OrnataSampleInventory.refresh(root).catch(() => {});
    });
    const seenPages = new Set();
    async function loadCatalog() {
      let next = rawCatalog.next;
      while (next) {
        const url = new URL(next, location.origin);
        if (url.origin !== location.origin || seenPages.has(url.href))
          throw new Error("Catalogus kon niet worden geladen");
        seenPages.add(url.href);
        url.searchParams.set("section_id", config.sectionId);
        const result = await fetch(url, { signal });
        if (!result.ok) throw new Error("Catalogus kon niet worden geladen");
        const doc = new DOMParser().parseFromString(
          await result.text(),
          "text/html",
        );
        const page = JSON.parse(
          doc.querySelector("[data-atelier-catalog]").textContent,
        );
        mergeCatalog(page.products);
        next = page.next;
      }
      catalogReady = true;
    }
    function prefill() {
      const params = new URLSearchParams(location.search),
        values = params.getAll("sample_set"),
        single = params.get("sample_product_id");
      if (values.length) {
        const ids =
          values.length === 1 && values[0].length <= 104
            ? values[0].split(",")
            : [];
        if (
          ids.length !== 5 ||
          new Set(ids).size !== 5 ||
          ids.some((id) => !/^\d{1,20}$/.test(id))
        ) {
          setNotice(
            "Deze advieslink is niet compleet. Vraag Ornata om een nieuwe link of stel zelf je set samen.",
          );
          return;
        }
        selected = ids.filter((id) => available(product(id)));
        slotIds = ids.map((id) => (selected.includes(id) ? id : null));
        mode = "self";
        selectedSet = null;
        if (selected.length === 5) {
          confirmedSet = {
            type: "self",
            ids: [...selected],
            slotIds: [...slotIds],
            name: "Voor jou samengesteld",
          };
          persist();
          writeForm();
          renderHomeSummary();
          heroModel?.setItems(confirmedItems(), false);
          setNotice(
            "Jouw vijf geuren staan klaar. Voeg je set toe aan je winkelmand.",
          );
        } else {
          confirmedSet = null;
          writeForm();
          renderHomeSummary();
          setNotice(
            "Een of meer geuren uit het advies zijn niet meer beschikbaar. De overige geuren staan klaar; vul je set aan.",
          );
          openAtelier("self");
        }
      } else if (single && available(product(single))) {
        selected = [single];
        slotIds = [single, null, null, null, null];
        mode = "self";
        openAtelier("self");
        params.delete("sample_product_id");
        history.replaceState(
          {},
          "",
          location.pathname + (params.size ? "?" + params : "") + location.hash,
        );
      }
    }
    let interacted = false;
    on(root, "click", (event) => {
      if (
        event.target.closest(
          '[data-start],[data-at="home-cta"],[data-edit-home],[data-remove-home]',
        )
      )
        interacted = true;
    });
    instances.set(root, () => {
      disposed = true;
      abort.abort();
      clearTimeout(toastTimer);
      animations.forEach((a) => {
        a.onfinish = null;
        a.cancel();
      });
      all("dialog[open]").forEach((d) => d.close());
      builderModel?.dispose();
      heroModel?.dispose();
      instances.delete(root);
    });
    renderHomeSummary();
    Promise.all([loadCatalog(), window.OrnataSampleInventory.ready(root)])
      .then(([, next]) => {
        if (disposed) return;
        hydrate(next);
        if (!interacted) prefill();
      })
      .catch(() => {
        if (!disposed)
          setNotice(
            "De geuren konden niet volledig worden geladen. Ververs de pagina of probeer het opnieuw.",
          );
      });
    if (config.enable3d)
      createBox($("#hero-stage"), {
        items: confirmedItems(),
      }).then((model) => {
        if (disposed) {
          model.dispose();
          return;
        }
        heroModel = model;
        heroModel.setItems(confirmedItems(), false);
      });
  }
  function scan(scope) {
    for (const root of scope.querySelectorAll("[data-ornata-atelier]"))
      mount(root);
  }
  window.OrnataSampleAtelier = { scan };
  document.addEventListener("shopify:section:load", (event) =>
    scan(event.target),
  );
  document.addEventListener("shopify:section:unload", (event) => {
    for (const [root, destroy] of instances)
      if (event.target.contains(root)) destroy();
  });
  scan(document);
})();

